import React from 'react';

import classes from './ModalTitle.module.scss';
import { LbChip } from '../../../../../shared/components/ui-components';

export const ModalTitle = () => {
  return (
    <div className={classes.title}>
      <LbChip size="small" color="info" label="New Update" />
      <h2>Important Updates & Features</h2>
    </div>
  );
};
